import React from "react";
import PluginRegistry from "../../pluginsInfrastructure/PluginRegistry";
import {
  ComponentToBeRegistered,
  Placeholder,
  PlaceholderPlugin,
  PluginEnableContext,
  SupportedPluginContentfulDataType,
} from "../../pluginsInfrastructure/PluginRegistryTypes";
import { isPhotobooks } from "./utils/photobooks";
import { PhotobooksEditorDownloadProps } from "./PhotobooksEditorDownload/PhotobooksEditorDownload";
import loadable from "@loadable/component";
import { productPageLayouts } from "../pluginOwners";

export const PhotobooksEditorDownloadComponent: ComponentToBeRegistered<PhotobooksEditorDownloadProps> = {
  placeholder: Placeholder.AfterCtas,
  Component: loadable<PhotobooksEditorDownloadProps>(() =>
    import("./PhotobooksEditorDownload/PhotobooksEditorDownload")
  ),
  name: "PhotobooksProductBuilderDownloadButtons",
  dataNeeds: {
    contentful: {
      offlineEditorMacDownload: {
        contentType: SupportedPluginContentfulDataType.SimpleLink,
        contentfulName: "Product Page > Offline Editor Mac Download",
      },
      offlineEditorWindowsDownload: {
        contentType: SupportedPluginContentfulDataType.SimpleLink,
        contentfulName: "Product Page > Offline Editor Windows Download",
      },
      designEditorDownloadInfo: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Design Editor Download Info",
      },
      compareEditors: {
        contentType: SupportedPluginContentfulDataType.DictionaryEntry,
        contentfulName: "Product Page > Compare Editors",
      },
    },
  },
  enable: (context: PluginEnableContext, parentComponents: string[]) => {
    const {
      pageProps: { mpv },
    } = context;
    return isPhotobooks(mpv.mpvId);
  },
};

export const photobooks: PlaceholderPlugin = {
  init(pluginRegistry: PluginRegistry) {
    pluginRegistry.addComponent(this, PhotobooksEditorDownloadComponent);
  },
  pluginOwner: productPageLayouts,
};
